import { GEOFENCE_TYPE_COLORS, FIELD_PIN_TYPES } from './mapUtils';

/**
 * Geofence / SOS legend content. Rendered inside the desktop bottom-left
 * floating box or the mobile "Legend" bottom sheet. (Phase key removed —
 * platoon phases read off the markers directly.)
 */
export default function MapLegend() {
  return (
    <div>
      <div>
        <div className="text-xs text-gray-500 mb-1.5 font-semibold">GEOFENCES</div>
        <div className="grid grid-cols-2 gap-x-3 gap-y-1">
          {Object.entries(GEOFENCE_TYPE_COLORS).map(([t, c]) => (
            <div key={t} className="flex items-center gap-1.5 text-xs">
              <span className="w-2.5 h-2.5 rounded-sm" style={{ backgroundColor: c }} />
              <span className="text-gray-400">
                {t}
                {FIELD_PIN_TYPES.includes(t) ? ' *' : ''}
              </span>
            </div>
          ))}
        </div>
        <div className="mt-1 text-[10px] text-gray-600">* field-dropped live pin</div>
      </div>

      <div className="mt-2 pt-2 border-t border-gray-700 flex items-center gap-2 text-xs">
        <span className="w-2.5 h-2.5 rounded-full bg-red-500 animate-pulse" />
        <span className="text-gray-400">SOS (independent flag)</span>
      </div>
    </div>
  );
}
